import { gray } from '../themePrimitives';

export const feedbackCustomizations = {
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          border: '1px solid',
          borderColor: (theme.vars || theme).palette.divider,
        },
      }),
    },
  },
  MuiModal: {
    styleOverrides: {
      backdrop: () => ({
        backdropFilter: 'blur(1px)',
        WebkitBackdropFilter: 'blur(1px)',
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: ({ theme }) => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[200],
        ...theme.applyStyles('dark', {
          backgroundColor: gray[800],
        }),
      }),
    },
  },
};
